import axios from 'axios';
import {
    submitPayloadDataFailure,
    submitPayloadDataSuccess,
} from '../../../actions/digitalSavings/payloadCollection';

import { getBeneficiaries, getIsApiPending,getBeneficiariesForms } from '../../../selectors/digitalSavings/beneficiaries';

import {
    getAccessToken,
} from '../../../selectors/digitalSavings/payment';
import { setExpiredAuth } from '../../../actions/digitalSavings/quote';
import { apiTransitionBeneficiariesForm } from '../../../actions/digitalSavings/beneficiaries';
import { getQuoteId } from '../../../selectors/digitalSavings/personalDetails';

export const beneficiariesSubmit = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionBeneficiariesForm.pending());
            try {
                const resp = await calculate(store.getState(), action);
                store.dispatch(submitPayloadDataSuccess(resp.data));
                store.dispatch(apiTransitionBeneficiariesForm.success());
            } catch (e) {
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                    store.dispatch(apiTransitionBeneficiariesForm.initial());
                } else {
                    store.dispatch(apiTransitionBeneficiariesForm.failure());
                }
                store.dispatch(submitPayloadDataFailure(e));
                
            }
        }
    })();
    return next(action);
};

const payloadCollection = (state, action) => {
    const beneficiaries = getBeneficiariesForms(state);
    const consent = getBeneficiaries(state);
    const qid = getQuoteId(state);

    function transformData(input) {
        return input?.map((item) => ({
            isBeneficiaryMinor: item.isMinor.value || false,
            firstName: item.isMinor.value ? item.firstNameMinor.value : item.firstName.value,
            lastName: item.isMinor.value ? item.lastNameMinor.value : item.lastName.value,
            identificationNumber: item.idNumber.value || null,
            relationship: item.relationship.value || null,
            location: item.isMinor.value ? item.locationMinor.value : item.location.value,
            phoneNumber: item.phoneNumber.value || null,
            emailAddress: item.email.value || null,
            percentageSplit: item.percentageSplit.value || null,
            guardianFirstName: item.isMinor.value ? item.firstName.value : null,
            guardianLastName: item.isMinor.value ? item.lastName.value : null,
            guardianIdentificationNumber: item.isMinor.value ? item.idNumber.value : null,
            guardianRelationship: item.isMinor.value ? item.relationship.value : null,
            guardianLocation: item.isMinor.value ? item.location.value : null,
            guardianPhoneNumber: item.isMinor.value ? item.phoneNumber.value : null,
            guardianEmailAddress: item.isMinor.value ? item.email.value : null,
        }));
    }

    const beneficiariesPayload = {
        quoteId: qid || 0,
        beneficiaries: beneficiaries.length > 0 ? transformData(beneficiaries) : [],
        consentForProcessingOutsideKenya: consent.personalDataProcessingConsent,
        consentForProcessingChildData: consent.childDataProcessingConsent,
        // consentForMarketingPurposes: true,
        consentForNewProductsAndServices: consent.consentForNewProductsAndServices,
        consentForProductsAndServicesRelatedWithMyPolicy: consent.consentForProductsAndServicesRelatedWithMyPolicy,
        noConsentForMarketingPurposes: consent.noConsentForMarketingPurposes,
    };
    
    return {
        ...beneficiariesPayload,
    };
};

const calculate = async (state, action) => {
    const loginData = getAccessToken(state);

    try {
        const url = '/om-api/digital-savings/beneficiaries';
        return await axios.post(url, payloadCollection(state, action), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        throw e;
    }
};
